import { render, staticRenderFns } from "./CustomSideNavbar.vue?vue&type=template&id=2f7a098e&scoped=true&"
import script from "./CustomSideNavbar.vue?vue&type=script&lang=js&"
export * from "./CustomSideNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a098e",
  null
  
)

export default component.exports